import { confirm } from '@@/modals/confirm';

import { GitFormModel } from './types';

export function getAuthentication(
  model: Pick<
    GitFormModel,
    | 'RepositoryAuthentication'
    | 'RepositoryPassword'
    | 'RepositoryUsername'
    | 'RepositoryGitCredentialID'
    | 'RepositoryAuthorizationType'
  >
) {
  if (!model.RepositoryAuthentication) {
    return undefined;
  }

  if (model.RepositoryGitCredentialID) {
    return { gitCredentialId: model.RepositoryGitCredentialID };
  }

  return {
    username: model.RepositoryUsername,
    password: model.RepositoryPassword,
    authorizationType: model.RepositoryAuthorizationType,
  };
}

export function confirmEnableTLSVerify() {
  return confirm({
    title: 'Enable TLS Verification?',
    message:
      'Enabling the verification of TLS certificates without ensuring the correct configuration of your Certificate Authority (CA) for self-signed certificates can result in deployment failures.',
  });
}

export function getRepositoryPathWithoutHost(input: string) {
  if (!input) {
    return '';
  }

  const trimmed = input.trim();

  // Handle scp-like SSH syntax: git@host:owner/repo(.git)
  const scpMatch = trimmed.match(/^[^@\s]+@[^:]+:(.+)$/);
  if (scpMatch && scpMatch[1]) {
    return sanitizePath(scpMatch[1]);
  }

  // Try URL parsing (https://, ssh://, git+ssh://, etc.)
  try {
    const url = new URL(trimmed);
    const path = url.pathname || '';
    return sanitizePath(path.replace(/^\/+/, ''));
  } catch {
    // Fallback best-effort: strip protocol and hostname if present
    const withoutProtocol = trimmed.replace(
      /^[a-zA-Z][a-zA-Z0-9+.-]*:\/\//,
      ''
    );
    const firstSlash = withoutProtocol.indexOf('/');
    if (firstSlash >= 0) {
      return sanitizePath(withoutProtocol.slice(firstSlash + 1));
    }
    return sanitizePath(withoutProtocol);
  }

  function sanitizePath(p: string) {
    return p
      .replace(/^\/+/, '')
      .replace(/\.git$/, '')
      .replace(/\/$/, '');
  }
}
